module.exports = __webpack_public_path__ + "img/7.31425f6e.jpg";